import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setModalContent(null);
  return <>
      <footer className="py-16 border-t border-white/5 text-center px-5 bg-dark" data-id="element-24">
        <div className="flex items-center justify-center gap-6 text-sm mb-6" data-id="element-25">
          <button onClick={() => setModalContent('privacy')} className="bg-transparent border-none text-white/40 underline cursor-pointer text-[11px] uppercase transition-colors hover:text-gold" data-id="element-26">
            Privacy Policy
          </button>
          <span className="text-white/20" data-id="element-27">|</span>
          <button onClick={() => setModalContent('terms')} className="bg-transparent border-none text-white/40 underline cursor-pointer text-[11px] uppercase transition-colors hover:text-gold" data-id="element-28">
            Terms of Service
          </button>
        </div>
        <p className="text-[10px] opacity-30 mt-8 tracking-[1px] leading-relaxed max-w-2xl mx-auto uppercase" data-id="element-29">
          © 2026 EL CÓDIGO 888. ESTE SITIO NO ES PARTE DE FACEBOOK O META INC.{' '}
          <br data-id="element-30" />
          DERECHOS RESERVADOS. REPROGRAMACIÓN TOTAL DE LIQUIDEZ.
        </p>
      </footer>

      {/* Legal Modal */}
      {modalContent && <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-31">
          <div className="bg-[#0f0f11] border border-gold/30 rounded-xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl" data-id="element-32">
            <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-33">
              <h3 className="text-xl font-serif font-bold text-gold uppercase tracking-wider" data-id="element-34">
                {modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'}
              </h3>
              <button onClick={closeModal} className="text-white/50 hover:text-white transition-colors" data-id="element-35">
                <X size={24} data-id="element-36" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto text-sm opacity-80 space-y-6 leading-relaxed" data-id="element-37">
              {modalContent === 'privacy' ? <>
                  <p data-id="element-38">
                    <strong data-id="element-39">1. Recopilación de Información</strong>
                    <br data-id="element-40" />
                    Recopilamos información cuando te registras en nuestro
                    sitio, realizas una compra, o participas en el sitio. La
                    información recopilada incluye tu nombre, dirección de
                    correo electrónico y detalles de pago.
                  </p>

                  <p data-id="element-41">
                    <strong data-id="element-42">2. Uso de la Información</strong>
                    <br data-id="element-43" />
                    Cualquier información que recopilemos de ti puede ser
                    utilizada para: personalizar tu experiencia, mejorar nuestro
                    sitio web, procesar transacciones y enviar correos
                    electrónicos periódicos.
                  </p>

                  <p data-id="element-44">
                    <strong data-id="element-45">3. Privacidad del Comercio Electrónico</strong>
                    <br data-id="element-46" />
                    Somos los únicos propietarios de la información recopilada
                    en este sitio. Tu información personal no será vendida,
                    intercambiada, transferida o dada a ninguna otra empresa por
                    ningún motivo, sin tu consentimiento, excepto para el
                    propósito expreso de entregar el producto adquirido.
                  </p>

                  <p data-id="element-47">
                    <strong data-id="element-48">4. Píxel de Meta y Seguimiento</strong>
                    <br data-id="element-49" />
                    Utilizamos el Píxel de Meta (Facebook) y otras tecnologías
                    de seguimiento para comprender cómo interactúas con nuestro
                    sitio web y para optimizar nuestras campañas publicitarias.
                    Esto nos permite mostrarte anuncios relevantes basados en
                    tus intereses.
                  </p>

                  <p data-id="element-50">
                    <strong data-id="element-51">5. Consentimiento</strong>
                    <br data-id="element-52" />
                    Al utilizar nuestro sitio, aceptas nuestra política de
                    privacidad.
                  </p>
                </> : <>
                  <p data-id="element-53">
                    <strong data-id="element-54">1. Aceptación de los Términos</strong>
                    <br data-id="element-55" />
                    Al acceder y utilizar este sitio web y adquirir "El Código
                    888", aceptas estar sujeto a estos Términos de Servicio y a
                    todas las leyes y regulaciones aplicables.
                  </p>

                  <p data-id="element-56">
                    <strong data-id="element-57">2. Naturaleza del Producto</strong>
                    <br data-id="element-58" />
                    "El Código 888" es un producto digital (audio y manual en
                    PDF). Al realizar la compra, recibirás acceso inmediato para
                    descargar o visualizar el contenido. No se enviará ningún
                    producto físico.
                  </p>

                  <p data-id="element-59">
                    <strong data-id="element-60">3. Política de Reembolsos</strong>
                    <br data-id="element-61" />
                    Debido a la naturaleza digital e inmediatamente accesible de
                    este producto, todas las ventas son finales. No ofrecemos
                    reembolsos una vez que el producto ha sido entregado
                    digitalmente, a menos que la ley local exija lo contrario.
                  </p>

                  <p data-id="element-62">
                    <strong data-id="element-63">4. Propiedad Intelectual</strong>
                    <br data-id="element-64" />
                    Todo el contenido incluido en este producto (textos, audios,
                    gráficos, logotipos) es propiedad exclusiva de El Código
                    888. Queda estrictamente prohibida su reproducción,
                    distribución o reventa sin autorización expresa por escrito.
                  </p>

                  <p data-id="element-65">
                    <strong data-id="element-66">5. Exención de Responsabilidad</strong>
                    <br data-id="element-67" />
                    La información y los audios proporcionados tienen fines
                    puramente educativos y de entretenimiento. No garantizamos
                    resultados financieros específicos. Los testimonios
                    mostrados son experiencias individuales y no constituyen una
                    garantía de resultados similares. No somos asesores
                    financieros ni médicos.
                  </p>
                </>}
            </div>

            <div className="p-6 border-t border-white/10 text-right" data-id="element-68">
              <button onClick={closeModal} className="px-6 py-2 bg-white/10 hover:bg-white/20 rounded text-sm font-bold transition-colors" data-id="element-69">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}